export const MOBILE_VIEW_BREAKPOINT_PX = 796;
